/** Listing-market labels only. Never converts readings, prices, or financial evidence.
 * Missing country falls back to miles, matching the established public web policy.
 * Callers may supply trusted booking/account country after the listing country.
 */
const MILES_COUNTRIES = new Set(["US", "GB", "LR", "MM"]);

export function listingDistanceUnit(...countries: Array<string | null | undefined>): "mi" | "km" {
  const country = countries.find(c => typeof c === "string" && c.trim())?.trim().toUpperCase();
  return !country || MILES_COUNTRIES.has(country) ? "mi" : "km";
}

export function listingMileageUnits(...countries: Array<string | null | undefined>): 1 | 2 {
  return listingDistanceUnit(...countries) === "mi" ? 1 : 2;
}